import { Color3 } from '@babylonjs/core/Maths/math.color'
import { Scene } from '@babylonjs/core/scene'
import ModelViewer from '../ModelViewer'

const falloff = 1.1
const offset = 0.03
let _viewer: ModelViewer

export function setFogEnabled(viewer: ModelViewer, enable: boolean) {
	_viewer = viewer
	if (enable) {
		viewer.scene.fogMode = Scene.FOGMODE_LINEAR
		const color = viewer.scene.clearColor.clone()
		viewer.scene.fogColor = new Color3(color.r, color.g, color.b).scale(2) // Don't ask
		viewer.scene.registerBeforeRender(calculateDistance)
	} else {
		viewer.scene.fogMode = Scene.FOGMODE_NONE
		viewer.scene.unregisterBeforeRender(calculateDistance)
	}
}

function calculateDistance(): void {
	const distance = _viewer.camera.radius
	_viewer.scene.fogStart = distance + offset
	_viewer.scene.fogEnd = (distance + offset) * falloff
	_viewer.camera.maxZ = _viewer.camera.radius + 0.02
}
